<template>
   <div class="layout-px-spacing" v-if="this.$can('admin')">
      <portal to="breadcrumb">
         <ul class="navbar-nav flex-row">
            <li>
               <div class="page-header">
                  <nav class="breadcrumb-one" aria-label="breadcrumb">
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="javascript:;">{{ $t('user') }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('edit') }}</span></li>
                     </ol>
                  </nav>
               </div>
            </li>
         </ul>
      </portal>

      <div class="row layout-spacing">
         <div id="flFormsGrid" class="col-lg-12 layout-top-spacing">
            <div class="statbox panel box box-shadow">
               <div class="panel-heading">
                  <div class="row">
                     <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                        <h4>{{ $t('edit_user') }}</h4>
                     </div>
                  </div>
               </div>
               <div class="panel-body">
                  <b-form @submit.prevent="submitForm" ref="form">
                     <div class="row align-items-center mb-md-4">
                        <div class="col-12 mt-md-0 mt-4">
                           <b-form-row>
                              <b-form-group :label="$t('first_and_last_name')" class="col-md-4">
                                 <b-form-input ref="meno" :state="validateState('meno')" v-model="$v.form.meno.$model" type="text"
                                 :placeholder="$t('first_and_last_name')"></b-form-input>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group :label="$t('email')" class="col-md-4">
                                 <b-input :state="validateState('email')" v-model="$v.form.email.$model" type="email"
                                         :placeholder="$t('email')"></b-input>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group :label="$t('password')" class="col-md-4">
                                 <b-input :state="validateState('heslo')" v-model="$v.form.heslo.$model" type="password"
                                 :placeholder="$t('password')"></b-input>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row>
                              <b-form-group class="col-md-4" :label="$t('town')">
                                 <b-select :state="validateState('selectedTown')" v-model="$v.form.selectedTown.$model">
                                    <b-select-option :value="null">{{ $t('select') }}</b-select-option>
                                    <b-select-option v-for="town in towns" :value="town.id" :key="town.id">
                                       {{ town.town_name }}
                                    </b-select-option>
                                 </b-select>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group class="col-md-4" :label="$t('role')">
                                 <b-select :state="validateState('selectedRola')" v-model="$v.form.selectedRola.$model">
                                    <b-select-option :value="null">{{ $t('select') }}</b-select-option>
                                    <b-select-option v-for="rola in roles" :value="rola.id" :key="rola.id">
                                       {{ rola.name }}
                                    </b-select-option>
                                 </b-select>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group class="col-md-4" :label="$t('language')">
                                 <b-select :state="validateState('language')" v-model="$v.form.language.$model">
                                    <b-select-option :value="null">{{ $t('select') }}</b-select-option>
                                    <b-select-option v-for="lang in availableLanguages" :value="lang.code" :key="lang.code">
                                       {{ lang.name }}
                                    </b-select-option>
                                 </b-select>
                                 <b-form-invalid-feedback>{{ $t('required_field') }}</b-form-invalid-feedback>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row>
                              <b-form-checkbox
                                id="checkbox-1"
                                v-model="form.default_store">
                                {{ $t('default_warehouse') }}
                              </b-form-checkbox>
                           </b-form-row>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-12 text-right">
                           <b-button @click="$router.go(-1)" variant="cancel" class="mt-3">{{ $t('cancel') }}</b-button>
                           <b-button type="submit" variant="default" class="mt-3 ml-2">{{ $t('save') }}</b-button>
                        </div>
                     </div>
                  </b-form>
               </div>
            </div>
         </div>
         <div class="col-lg-12 layout-top-spacing">
            <div class="statbox panel box box-shadow">
               <div class="panel-heading" style="cursor: pointer;" @click="showPermissions = !showPermissions">
                  <h5 class="mb-0">
                     Prehľad právomocí podľa rolí
                     <span style="float: right;">{{ showPermissions ? '−' : '+' }}</span>
                  </h5>
               </div>
               <b-collapse v-model="showPermissions" id="permissions-collapse">
                  <div class="panel-body">
                     <div class="row">
                        <div class="col-md-6 mb-3">
                           <h6><strong>ADMIN (admin)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Všetky<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-success">✓</span> Prístup<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-success">✓</span> Správa<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>OFFICE (office)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Všetky<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-success">✓</span> Prístup<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>OBCHODNÍK MANAGER (obchodnik-manager)</strong></h6>
                           • Objednávky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-success">✓</span> Prístup<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>OBCHODNÍK (obchodnik)</strong></h6>
                           • Objednávky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>TECHNIK MANAGER (technik-manager)</strong></h6>
                           • Objednávky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-success">✓</span> Prístup<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>TECHNIK (technik)</strong></h6>
                           • Objednávky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>INFOLINKA (infolinka)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Všetky<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>KURIER (kurier)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Iba pokiaľ je ako odosielateľ, príjemca alebo v výdajke/príjemke<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>SKLADNÍK (skladnik)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Iba pokiaľ je ako odosielateľ, príjemca alebo v výdajke/príjemke<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-success">✓</span> Prístup<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>ROLA-POBOCKA (rola-pobocka)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Iba pokiaľ je ako odosielateľ, príjemca alebo v výdajke/príjemke<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                        <div class="col-md-6 mb-3">
                           <h6><strong>REKLAMACIE (reklamacie)</strong></h6>
                           • Objednávky: <span class="text-success">✓</span> Iba pokiaľ je ako odosielateľ, príjemca alebo v výdajke/príjemke<br>
                           • Môj sklad: <span class="text-success">✓</span> Prístup<br>
                           • História: <span class="text-success">✓</span> Prístup<br>
                           • Položky: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Položky používateľov: <span class="text-success">✓</span> Všetkých používateľov (okrem obchodníkov, manažérov a infolinky)<br>
                           • Používatelia: <span class="text-danger">✗</span> Bez prístupu<br>
                           • Návody: <span class="text-success">✓</span> Prístup
                        </div>
                     </div>
                  </div>
               </b-collapse>
            </div>
         </div>
      </div>
   </div>
   <div class="layout-px-spacing d-flex align-items-center justify-content-center" v-else>
      <div class="row layout-top-spacing">
         <div class="col-12">
            <h4 class="text-center px-3">{{ $t('not_allowed') }}</h4>
         </div>
      </div>
   </div>
</template>

<script>
   import { validationMixin } from "vuelidate";
   import { email, required } from "vuelidate/lib/validators";

   export default {
      name: "edit",
      mixins: [validationMixin],
      validations: {
         form: {
            meno: {
               required
            },
            email: {
               required,
               email
            },
            heslo: {},
            selectedRola: {
               required
            },
            selectedTown: {
               required
            },
            language: {
               required
            }
         }
      },
      data() {
         return {
            userActual: {},
            roles: {},
            towns: {},
            languageCodes: ['sk', 'cz', 'pl', 'hu'],
            showPermissions: false,
            form: {
               id: "",
               meno: "",
               email: "",
               cislo: "",
               heslo: "",
               language: "",
               selectedRola: null,
               selectedTown: null,
               default_store: false
            }
         };
      },
      computed: {
         availableLanguages() {
            return this.languageCodes.map(code => ({
               code: code,
               name: this.$t(code)
            }));
         }
      },
      created() {

         this.$axios.get("roles")
           .then((response) => {
              this.roles = response.data;
           });

         this.$axios.get("towns")
           .then((response) => {
              this.towns = response.data;
           });

         this.$axios.get("users/" + this.$route.params.pouzivatel)
           .then((response) => {
              this.userActual = response.data;
           });
         this.$v.form.$touch();
      },
      watch: {
         userActual(user) {
            this.form.meno = user.name;
            this.form.email = user.email;
            this.form.cislo = user.phone;
            this.form.language = user.language;
            this.form.selectedTown = user.town_id;
            this.form.selectedRola = user.role.id;
            this.form.default_store = user.default_store;
         }
      },
      methods: {
         validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
         },
         submitForm() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
               this.$toast.error(this.$t("missing_credentials"));
               return;
            }

            let data = {
               name: this.form.meno,
               email: this.form.email,
               phone: this.form.cislo,
               language: this.form.language,
               town_id: this.form.selectedTown,
               rola: this.form.selectedRola,
               default_store: this.form.default_store,
               _method: "PATCH"
            };

            let formData = new FormData();

            if (this.form.heslo) {
               formData.append("password", this.form.heslo);
            }

            for (let key in data) {
               formData.append(key, data[key]);
            }


            this.$axios.post("users/" + this.userActual.id, formData)
              .then((response) => {
                 this.$store.dispatch("auth/getUserData");
                 this.$router.go(- 1);
                 this.$toast.success(response.data.message);
              }).catch(error => {
               this.$store.dispatch("loader/done");
               this.$toast.error(error.response.data.message);
            });
         }
      }
   };
</script>
